'use client';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { FunctionComponent, useMemo } from 'react';
import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';
import { UserDropdownTrigger } from './Trigger';
import { UserDropdownContent } from './Content';
import { useIam } from '../../../../../services/IAm/hooks';
import styles from './styles.module.scss';

export type UserDropdownProps = {
    educatorId?: string;
};

export const UserDropdown: FunctionComponent<UserDropdownProps> = ({ educatorId }) => {
    const { iam } = useIam();
    const pathname = usePathname();
    const searchParams = useSearchParams();

    const loginUrl = useMemo(() => {
        const path = `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/login`;
        const nextSearchParams = new URLSearchParams();

        if (pathname && searchParams) {
            const redirectPath = searchParams.toString() ? `${pathname}?${searchParams}` : pathname;
            nextSearchParams.set('redirect', redirectPath);
        }

        if (educatorId) {
            nextSearchParams.set('educator', educatorId);
        }

        return `${path}?${nextSearchParams.toString()}`;
    }, [pathname, searchParams, educatorId]);

    if (!iam.authenticated) {
        return (
            <Link href={loginUrl} className={styles.loginLink}>
                Log in
            </Link>
        );
    }

    return (
        <DropdownMenu.Root modal={false}>
            <UserDropdownTrigger className={styles.userDropdownTrigger} />
            <DropdownMenu.Portal>
                <UserDropdownContent educatorId={educatorId} />
            </DropdownMenu.Portal>
        </DropdownMenu.Root>
    );
};
